import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContextRedux'

export default function MenuPage() {
  const navigate = useNavigate()
  const { logout } = useAuth()

  return (
    <div className="min-h-screen bg-base-200 flex flex-col">
      {/* Header */}
      <div className="navbar bg-base-100 shadow-sm px-6">
        <div className="flex-1">
          <span className="text-xl font-bold">TEVV Pipeline</span>
        </div>
        <div className="flex-none">
          <button className="btn btn-ghost btn-sm" onClick={logout}>
            Sign Out
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl w-full">
          {/* Generator Card */}
          <div
            className="card bg-base-100 shadow-xl cursor-pointer hover:shadow-2xl transition-shadow border-2 border-transparent hover:border-primary"
            onClick={() => navigate('/generator')}
          >
            <div className="card-body items-center text-center p-10">
              <div className="text-5xl mb-4">🧬</div>
              <h2 className="card-title text-2xl mb-2">Persona & Episode Generator</h2>
              <p className="text-base-content/70 mb-4">
                Create patient personas based on sleep disorder dimensions and generate
                multi-episode clinical journey simulations with AI-powered dialogue.
              </p>
              <div className="flex flex-wrap gap-2 justify-center">
                <span className="badge badge-primary badge-outline">Personas</span>
                <span className="badge badge-secondary badge-outline">Episodes</span>
                <span className="badge badge-accent badge-outline">Dialogue</span>
              </div>
            </div>
          </div>

          {/* OSA Multi-Agent Cockpit */}
          <div
            className="card bg-base-100 shadow-xl cursor-pointer hover:shadow-2xl transition-shadow border-2 border-transparent hover:border-primary"
            onClick={() => navigate('/osa')}
          >
            <div className="card-body items-center text-center p-10">
              <div className="text-5xl mb-4">🫁</div>
              <h2 className="card-title text-2xl mb-2">OSA Multi-Agent Cockpit</h2>
              <p className="text-base-content/70 mb-4">
                Run a chapter-grounded clinical agent against blinded OSA patient cases
                (Fundamentals 19). Per-phase + ground-truth evaluation included.
              </p>
              <div className="flex flex-wrap gap-2 justify-center">
                <span className="badge badge-primary badge-outline">OSA</span>
                <span className="badge badge-secondary badge-outline">RAG</span>
                <span className="badge badge-accent badge-outline">Ground truth</span>
              </div>
            </div>
          </div>

          {/* Chat Card */}
          <div
            className="card bg-base-100 shadow-xl cursor-pointer hover:shadow-2xl transition-shadow border-2 border-transparent hover:border-primary"
            onClick={() => navigate('/chat')}
          >
            <div className="card-body items-center text-center p-10">
              <div className="text-5xl mb-4">💬</div>
              <h2 className="card-title text-2xl mb-2">Research Chat</h2>
              <p className="text-base-content/70 mb-4">
                Ask research questions about sleep disorders in the elderly. Get AI-synthesized
                answers backed by PubMed, ArXiv, and curated literature.
              </p>
              <div className="flex flex-wrap gap-2 justify-center">
                <span className="badge badge-primary badge-outline">PubMed</span>
                <span className="badge badge-secondary badge-outline">ArXiv</span>
                <span className="badge badge-accent badge-outline">Citations</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
